var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "title" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["switch", { closed: _vm.checked }],
        on: { click: _vm.hadleChange }
      },
      [_c("span", { class: [{ closed: _vm.checked }] })]
    ),
    _vm._v(" "),
    _c("input", {
      attrs: { type: "checkbox", disabled: _vm.disabled },
      domProps: { value: _vm.value },
      on: { change: _vm.hadleChange }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }